/** Phase 19 */
import { listAggregateExpiredProducts } from '../infrastructure/storage/domainAggregateStore';
import { listEntityExpiredProducts } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'expiredProducts',
  listAggregate: listAggregateExpiredProducts,
  listEntity: listEntityExpiredProducts,
  idKeys: ['id', 'lotId']
});

export const readExpiredProductsFromMergedBlob = source.readFromMergedBlob;
export const readExpiredProductsFromBestSource = source.readFromBestSource;
export const refreshExpiredProductsReadCache = source.refreshReadCache;
export const getCachedExpiredProductsRead = source.getCachedRead;
export const clearExpiredProductsReadCache = source.clearReadCache;
export const readExpiredProductsSyncForBusiness = source.readSyncForBusiness;
